import { globalAxiosInstance } from "../../../apiCalls/utils/axios";
import { makeRequest } from "../../../apiCalls/utils/makeRequest";

export const useGetMappings = makeRequest({
  baseUrl: process.env.REACT_APP_VEHICLES_API || "",
  buildQuery: () => "/template_values_mappings",
  axiosInstance: globalAxiosInstance,
  method: "get",
  withInitialLoading: true,
  transformResponse: (response: any) => response?.data,
});


export const useCreateMapping = makeRequest({
  baseUrl: process.env.REACT_APP_VEHICLES_API || "",
  axiosInstance: globalAxiosInstance,
  method: "post",
  buildQuery: () => `/template_values_mappings`,
  buildData: (data: any) => data,
});


export const useEditMapping = makeRequest({
  baseUrl: process.env.REACT_APP_VEHICLES_API || "",
  axiosInstance: globalAxiosInstance,
  method: "put",
  buildQuery: ({ data }: any) => `/template_values_mappings/${data?.name}`,
  buildData: (data: any) => data,
});

export const useGetMapping = makeRequest({
  baseUrl: process.env.REACT_APP_VEHICLES_API || "",
  axiosInstance: globalAxiosInstance,
  method: "get",
  buildQuery: (data) => {
    return `/template_values_mappings/${data?.data}`
  },
});


export const useDeleteMapping = makeRequest({
  baseUrl: process.env.REACT_APP_VEHICLES_API || "",
  axiosInstance: globalAxiosInstance,
  method: "delete",
  buildQuery: ({ data }: any) => `/template_values_mappings/${data?.name}`
});
